import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";
import { IWorkingHoursFormModel, workingHoursFormSchema } from "../validation/workingHoursValidation";
import { DayKey, DAYS_OF_WEEK, IWorkingHoursData, workingHoursFormDefaultValues } from "../models/models";

export const useWorkingHoursForm = (initialData?: IWorkingHoursData) => {
  const form = useForm<IWorkingHoursFormModel>({
    defaultValues: workingHoursFormDefaultValues,
    resolver: yupResolver(workingHoursFormSchema),
  });

  const fieldArrays = {
    monday: useFieldArray({ control: form.control, name: "monday" }),
    tuesday: useFieldArray({ control: form.control, name: "tuesday" }),
    wednesday: useFieldArray({ control: form.control, name: "wednesday" }),
    thursday: useFieldArray({ control: form.control, name: "thursday" }),
    friday: useFieldArray({ control: form.control, name: "friday" }),
    saturday: useFieldArray({ control: form.control, name: "saturday" }),
    sunday: useFieldArray({ control: form.control, name: "sunday" }),
  };

  const transformApiDataToFormData = (
    apiData: IWorkingHoursData
  ): IWorkingHoursFormModel => {
    const formData: IWorkingHoursFormModel = {
      ...workingHoursFormDefaultValues,
    };

    formData.studioId = apiData.studioId;
    formData.userId = apiData.userId;

    // Map days to form structure
    apiData.days.forEach((day) => {
      const dayKey = DAYS_OF_WEEK.find(
        (d) => d.dayOfWeek === day.dayOfWeek
      )?.key;
      if (dayKey) {
        formData[dayKey] = day.slots || [];
      }
    });

    return formData;
  };

  useEffect(() => {
    if (initialData) {
      const formData = transformApiDataToFormData(initialData);
      form.reset(formData);
    }
  }, [initialData, form]);

  useFormValidationMessages<IWorkingHoursFormModel>(form);

  const addTimeSlot = (dayKey: DayKey) => {
    fieldArrays[dayKey].append({ startTime: "09:00", endTime: "18:00" });
  };

  const removeTimeSlot = (dayKey: DayKey, index: number) => {
    fieldArrays[dayKey].remove(index);
  };

  return {
    form,
    fieldArrays,
    addTimeSlot,
    removeTimeSlot,
  };
};
